import React from 'react';
import PropTypes from 'prop-types';
import AppBreadcrumbs from 'components/AppBreadcrumbs';
import PageLayout from 'layouts/PageLayout';
import { makeStyles } from '@material-ui/core/styles';
import { useAsyncFn } from 'react-use';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createTrainingSession } from 'http/trainingSessions';
import { routesAliases } from 'router/routesAliases';
import TrainingSessionForm from '../TrainingSessionForm';

const useStyles = makeStyles(theme => ({
  pageContent: {
    padding: theme.spacing(4, 5),
  },
}));

const Create = ({ routeProps }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('common');
  const backUrl = routesAliases.trainingSessionsList;

  const breadCrumbsItems = [
    {
      title: t(routeProps.parentTitle),
      link: routeProps.parentPath,
    },
    {
      title: t(routeProps.title),
      isActive: true,
    },
  ];

  const [submittingState, sendForm] = useAsyncFn(async formData => {
    const result = await createTrainingSession(formData);
    if (!result.error && !(result.statusCode && result.statusCode >= 400)) {
      toast.success(t('trainingSessions.saveSuccess'));
      history.push(`${routesAliases.editTrainingSession}/${result.id}`);
    }
    return result;
  });

  return (
    <PageLayout classes={{ content: classes.pageContent }} pageTitle={<AppBreadcrumbs items={breadCrumbsItems} />}>
      <TrainingSessionForm
        mode="create"
        onSubmitForm={sendForm}
        submitting={submittingState.loading}
        backUrl={backUrl}
      />
    </PageLayout>
  );
};

Create.propTypes = {
  routeProps: PropTypes.shape({
    parentPath: PropTypes.string,
    parentTitle: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default Create;
